import InputSlider from '@/components/sections/builder/settings/input-slider';
import { ThemeDropdownPopupType, useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export const DEFAULT_THEME_DROPDOWN_POPUP: ThemeDropdownPopupType = {
  borderWidth: 1,
  borderOpacity: 0,
  borderRadius: 8,
  shadowOpacity: 0,
  horizontalOffset: 0,
  verticalOffset: 0,
  shadowBlur: 0,
};

export default function ThemeDropdownPopupSetting() {
  const builder = useBuilderStore(
    (state) => ({
      theme: state.theme,
      setTheme: state.setTheme,
    }),
    shallow
  );

  const dropdownPopup = builder.theme?.dropdownPopup || DEFAULT_THEME_DROPDOWN_POPUP;

  const setValue = (value: Partial<ThemeDropdownPopupType>) => {
    builder.setTheme({
      dropdownPopup: { ...dropdownPopup, ...value },
    });
  };

  return (
    <div>
      <div className='mb-4 font-bold'>Border</div>
      <InputSlider
        label='Thickness'
        value={dropdownPopup.borderWidth}
        max={24}
        min={0}
        onChange={(val) => setValue({ borderWidth: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Opacity'
        value={dropdownPopup.borderOpacity}
        max={100}
        min={0}
        onChange={(val) => setValue({ borderOpacity: val })}
        rightContent={<div>%</div>}
      />
      <InputSlider
        label='Corner radius'
        value={dropdownPopup.borderRadius}
        max={40}
        min={0}
        onChange={(val) => setValue({ borderRadius: val })}
        rightContent={<div>px</div>}
      />
      <div className='mb-4 mt-4 font-bold'>Shadow</div>
      <InputSlider
        label='Opacity'
        value={dropdownPopup.shadowOpacity}
        max={100}
        min={0}
        onChange={(val) => setValue({ shadowOpacity: val })}
        rightContent={<div>%</div>}
      />
      <InputSlider
        label='Horizontal offset'
        value={dropdownPopup.horizontalOffset}
        max={40}
        min={0}
        onChange={(val) => setValue({ horizontalOffset: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Vertical offset'
        value={dropdownPopup.verticalOffset}
        max={40}
        min={0}
        onChange={(val) => setValue({ verticalOffset: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Blur'
        value={dropdownPopup.shadowBlur}
        max={40}
        min={0}
        onChange={(val) => setValue({ shadowBlur: val })}
        rightContent={<div>px</div>}
      />
    </div>
  );
}
